import { render, staticRenderFns } from "./CoreUpload.vue?vue&type=template&id=4f601c54&scoped=true"
import script from "./CoreUpload.vue?vue&type=script&lang=js"
export * from "./CoreUpload.vue?vue&type=script&lang=js"
import style0 from "./CoreUpload.vue?vue&type=style&index=0&id=4f601c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f601c54",
  null
  
)

export default component.exports